import React, { useState } from 'react'
import Form from './form'

export default function CourseAdd (props) {
  const [data, setData] = useState({ active: false })

  return <Form data={data} setData={setData} {...props} />
}
